module.exports = "/images/vendor/flag-icon-css/flags/4x3/pe.svg?ea95116f76c82964116d1575f7b8376a";